import { c as _c } from "react/compiler-runtime";
import { PROFILE_PROXY_ACTION_LABELS } from "@/entities/IProxy";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
export default function ProxyCreateActionSelectTypeItem(t0) {
  const $ = _c(6);
  const {
    actionType,
    setSelectedActionType
  } = t0;
  let t1;
  if ($[0] !== actionType || $[1] !== setSelectedActionType) {
    t1 = () => setSelectedActionType(actionType);
    $[0] = actionType;
    $[1] = setSelectedActionType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = PROFILE_PROXY_ACTION_LABELS[actionType];
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <li className="tw-ring-1 tw-ring-iron-600 tw-rounded-lg"><button type="button" onClick={t1} className="tw-border-0 tw-bg-iron-950 tw-px-3 tw-py-2.5 tw-font-medium tw-text-iron-300 tw-text-sm tw-rounded-lg hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out">{t2}</button></li>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}